"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getAppMembersReference_1 = __importDefault(require("../../firebase/projects/getAppMembersReference"));
const appStateSelectProjectId_1 = __importDefault(require("../../shared/appStateSelectProjectId"));
const callableGetAppUsers = async ({ callbacks, functionId, entryVars: { targetAppId, }, executeProcesses, processor, store, }) => {
    try {
        const database = processor === null || processor === void 0 ? void 0 : processor.root.firebase.database();
        if (typeof targetAppId !== 'string' || !targetAppId) {
            throw new Error(`Invalid targetAppId ${targetAppId}`);
        }
        const projectId = (0, appStateSelectProjectId_1.default)(store.getState());
        const membersRef = (0, getAppMembersReference_1.default)(database)(projectId)(targetAppId);
        let membersValue = await membersRef.get() || {};
        membersValue = Object.entries(membersValue).reduce((newMembersValue, [key, value]) => {
            const newData = Object.assign(Object.assign({}, newMembersValue), { [key]: value });
            delete newData[key].hashedPassword;
            delete newData[key].cloudMessagingTokens;
            return newData;
        }, {});
        executeProcesses(functionId, callbacks.successProcess, membersValue);
    }
    catch (error) {
        executeProcesses(functionId, callbacks.errorProcess, error);
    }
};
exports.default = callableGetAppUsers;
